/**
 * Created by lari on 24/04/2017. **/

(function () {
  'use strict';
  angular.module('vcexam')
    .component('examlist', {
      restrict: 'E',
      bindings: {
        exams: '<?',
        patientid: '<?'
      },
      templateUrl: 'vcexam/exam-list-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'Exam', '$http', 'Rlog', '$scope', 'uiGridConstants', 'PrintHelper', '$uibModal', 'vertxEventBusService', '$window',
        function ($log, Exam, $http, Rlog, $scope, uiGridConstants, PrintHelper, $uibModal, vertxEventBusService, $window) {
          let vm = this;
          vm.examactiontemplate = 'examactiontemplate';
          vm.editExam = editExam;
          vm.spinners = [];

          // init
          vm.$onInit = function () {
            // unless exam list has been passed for test purposes, retrieve exams list from web
            if (angular.isUndefined(vm.exams) && angular.isUndefined(vm.patientid)) {
              vm.exams = Exam.$search();
            }

            vm.gridOptions = {
              enableFiltering: true,
              columnDefs: [
                {
                  field: 'created', displayName: 'Datum', type: 'date', width: '15%',
                  cellTemplate: '<span>{{row.entity.created | moment: \'lll\'}}</span>',
                  filters: [
                    {
                      condition: uiGridConstants.filter.GREATER_THAN,
                      placeholder: 'nach'
                    },
                    {
                      condition: uiGridConstants.filter.LESS_THAN,
                      placeholder: 'vor'
                    }
                  ]
                },
                {
                  field: 'type', displayName: 'Typ', width: '20%',
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  field: 'diagnosis', displayName: 'Befund', width: '43%',
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  displayName: 'Aktion', name: 'examaction', cellClass: 'gridalignright', width: '20%',
                  cellTemplate: vm.examactiontemplate, enableFiltering: false
                }
              ],
              data: vm.exams
            };
          };




          // changes
          vm.$onChanges = function (changes) {
            if (angular.isDefined(changes.patientid) && angular.isDefined(changes.patientid.currentValue) && changes.patientid.currentValue.length > 0) {
              vm.patientid = changes.patientid.currentValue;
              vm.exams = Exam.$search({patientid: vm.patientid, active: true});
            }
          };


          function editExam(exam, index) {
            $log.debug('examlist editExam called with: ', exam, index);
            $uibModal.open({
              template: `
                <div class="modalspacer">
                  <postexameditor exam="lc.exam" dialog="lc.dialog"></postexameditor>
                </div>`,
              size: 'lg',
              controller: ['lexam', '$uibModalInstance', function (lexam, $uibModalInstance) {
                let lc = this;
                $log.debug('lexam inside modal controaller: ', lexam);
                lc.exam = lexam;
                lc.dialog = $uibModalInstance;
              }],
              controllerAs: 'lc',
              resolve: {
                lexam: () => {
                  $log.debug('exam inside resolve: ', exam);
                  return exam;
                }
              }
            });

          }


          const examsUpdateHandler =  function (message) {
            let messages = message.split(':');
            // only refresh exam if change was NOT triggered by this browser
            if (angular.isDefined(vm.exams) && messages[1] !== $window.sessionStorage.getItem('sprtabid')) {
              vm.exams.$refresh();
              $log.debug('(postexameditor) refreshed exams');
            }
            else {
              $log.debug(' (postexameditor) ignored exams change');
            }
          };


          $log.debug('[Vert.x subscribe] examinations.update');
          vertxEventBusService.on('examinations.update',{}, examsUpdateHandler);

          vm.$onDestroy = function () {
            $log.debug('[Vert.x unsubscribe] examinations.update');
            vertxEventBusService.unregisterHandler('examinations.update', {}, examsUpdateHandler);
          };



        }] // controller
    }); // component

  // klammerfriedhof
}());